/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubmittingInputs */



/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Feedback_SubmittingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_submitting = /** @type {((inputs?: Feedback_SubmittingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubmittingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviando…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviando…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio…")
	return /** @type {LocalizedString} */ ("Sending…")
});